<template>
  <div class="container">
    <div class="bankList">
      <a
        :href="bank.href"
        target="_blank"
        v-for="(bank, index) in bankList"
        :key="index"
        class="backInfo"
      >
        <div class="first">
          <img class="logo" :src="bank.logo" alt="" />
          <span class="name">{{ bank.name }}</span>
        </div>
        <div class="secound">
          <span class="introduce">{{ bank.introduce }}</span>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      bankList: [
        {
          name: "中国农业银行",
          logo: require("../assets/金融服务/中国农业银行.png"),
          href: "https://fas.abchina.com/elp/homepage",
          introduce: "农业银行惠农e贷特点：线上申请，快速审批放款、贷款利率低、3年可循环；线上线下多渠道服务；贷款方式可采取自助可循环和自助非循环；年化利率最低3.35%起。一次性利随本清、等额本息、等本递减分期、先息后本等多种还款方式灵活选择。",
        },
        {
          name: "中国工商银行",
          logo: require("../assets/金融服务/中国工商银行.png"),
          href: "https://m.icbc.com.cn/ICBC/kfssjyxkh9/46.htm",
          introduce: "工商银行养殖e贷：贷款对象为农户、农业经营主体（含家庭农场、农民专业合作社、农业企业）及其他涉农组织，根据单个经营周期设置，一般不超过1年，最长可至5年，年利率3.45%起，最高额度300万，借款人应具备融资对应养殖品类至少一个完整周期的养殖经验，且从事养殖行业一般不低于两年。",
        },
        {
          name: "中国建设银行",
          logo: require("../assets/金融服务/中国建设银行.png"),
          href: "http://yunkd.chuangyijiayuan.cn",
          introduce: "建设银行裕农快贷特点：信用贷款，无须抵押；在线完成方便快捷；贷款额度最高可达100万元;年化利率3.35%起；先息后本，随借随还。",
        },
        {
          name: "中国邮政储蓄银行",
          logo: require("../assets/金融服务/中国邮政储蓄银行.png"),
          href: "https://www.psbc.com/cn/snfw/###",
          introduce: "中国邮政储蓄银行：贷款对象为产业及商圈中的商户、农户等自然人发放的用于满足生产经营活动资金需求的贷款。贴近实际用款需求。结合各产业及商圈中商户、农户的实际生产经营周期，灵活设置贷款期限、还款方式等。信用类额度可达300万元。线上申请，快速放款。",
        },
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.container {
  min-height: 630px;
  margin: 0 auto;
  width: 1860px;
  background-color: #fff;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
  padding: 0 30px;
  padding-top: 30px;
  .bankList {
    display: flex;
    flex-flow: row wrap;
    width: 100%;
    height: auto;
    justify-content: space-between;
    .backInfo {
      display: flex;
      flex-flow: column nowrap;
      width: 49%;
      cursor: pointer;
      box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
      padding: 20px;
      margin-bottom: 20px;
      border-radius: 6px;
      .first {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        .logo {
          width: 80px;
          height: auto;
          display: block;
          margin-right: 16px;
        }
        .name {
          font-size: 26px;
          font-weight: 600;
        }
      }
      .secound {
        margin-top: 20px;
        text-indent: 2em;
        .introduce {
          font-size: 20px;
        }
      }
    }
  }
}
</style>